import { View } from "binder"
import { DataModelDesignerViewModel } from "./dataModelDesigner-viewModel"

export class DataModelDesignerView extends View<DataModelDesignerViewModel>{
    GetViewUniqueId(): string {
        return "V-9FF0FD3C-F75E-4F02-B1E0-0829B3416B4D"
    }
    loadHtml(): string {
        let element = require('./dataModelDesigner.html').default;
        let style = require('./dataModelDesigner.less');
        return element;
    }
    constructor() {
       super();
    }

    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async save(){
        this.dataContext.save();
    }

    async edit(){
        this.dataContext.edit();
    }

}
